module.exports = __webpack_public_path__ + "static/img/all_checked.1df54784.svg";